import Video from "next-video/player";

interface VideoPlayerProps {
  hlsPlaybackUrl: string;
  poster?: string;
}

export default function VideoPlayer({ hlsPlaybackUrl, poster }: VideoPlayerProps) {
  return (
    <div className="relative w-full h-full bg-[#323232]">
      <Video
        src={hlsPlaybackUrl}
        preferCmcd="header"
        style={{
          "--seek-backward-button": "none",
          "--seek-forward-button": "none",
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
        streamType="on-demand"
        className="video-player"
        autoPlay={false}
        accentColor="#e02013"
        poster={poster}
      />
    </div>
  );
}
